// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ShareButtons, generateShareIcon } from 'react-share';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import cx from 'classnames';
// Helper
import { trackEvent } from '../../utils/analytics/analyticsManager';
// Constants
import { eventCategory, eventAction, eventLabel } from '../../utils/analytics/analyticsConstants';
// Styles
import * as styles from './ShareBlock.scss';

const { FacebookShareButton } = ShareButtons;

const whatsAppMessage = {
  he: 'מצאתי דירה מעניינת ב- און מאפ שחשבתי שתעניין אותך:',
  en: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:',
  ru: 'Я нашел интересную квартиру на OnMap.co.il, которая, как я думал, заинтересует вас:',
  fr: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:'
};

const emailMessage = {
  he: { subject: 'דירה מעניינת ב- און מאפ', message: 'מצאתי דירה מעניינת ב- און מאפ שחשבתי שתעניין אותך:' },
  en: { subject: 'Interesting apartment on OnMap.co.il', message: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:' },
  ru: { subject: 'Интересная квартира на OnMap.co.il', message: 'Я нашел интересную квартиру на OnMap.co.il, которая, как я думал, заинтересует вас:' },
  fr: { subject: 'Interesting apartment on OnMap.co.il', message: 'I found an interesting apartment on OnMap.co.il, which I thought would interest you:' }
};

export default class ShareBlock extends Component {
  state = {
    linkCopied: false
  };

  shouldComponentUpdate(newProps, nextState) {
    const shouldCopyLink = nextState.linkCopied !== this.state.linkCopied;
    const localeIsChanged = (newProps.locale && newProps.locale !== this.props.locale);

    return (shouldCopyLink || localeIsChanged);
  }

  trackShareClick = () =>
    new Promise((resolve) => {
      resolve(trackEvent(eventCategory.share, eventAction.click, eventLabel.contactDetails));
    });

  handleCopyLink = () => {
    this.setState({ linkCopied: true });
    setTimeout(() => {
      this.setState({ linkCopied: false });
    }, 3000);
  };

  renderShareEmail = (sharingUrl) => {
    const { subject, message } = emailMessage[this.props.locale];
    const link = `mailto:?subject=${subject}&body=${message} ${sharingUrl}`;
    return (
      <a href={link} className={cx(styles.shareRow, styles.emailWrapper)}>
        <span className="icon icon-mailIcon" />
        {this.props.withSocialName && <span className={styles.name}>{this.props.translate('sendEmail')}</span>}
      </a>
    );
  };

  renderShouldCopyButton = () => (
    <div className={styles.copyLinkWrap}>
      <span className="icon icon-copyLink">
        <span className="path1" />
        <span className="path2" />
        <span className="path3" />
      </span>
    </div>
  );

  renderCopiedButton = () => (
    <span className="icon icon-circled-check" >
      <span className="path1" />
      <span className="path2" />
    </span>
  );

  renderFacebookIcon = () => (
    <span className="icon icon-facebookShare">
     <i className="path1" />
     <i className="path2" />
  </span>);

  renderWhatsAppIcon = () => (
    <span className="icon icon-whatsApp">
     <i className="path1" />
     <i className="path2" />
  </span>);

  render() {
    const {
      sharingData: { sharingUrl },
      isMobile,
      translate,
      className,
      iconFill,
      sizeIcon,
      inColumn,
      withSocialName
    } = this.props;
    const protocol = (sharingUrl.includes('://')) ? '' : 'https://';
    const shareText = `${encodeURIComponent(whatsAppMessage[this.props.locale])} ${protocol}${sharingUrl}`;
    const iconShouldFill = iconFill ? '-fill' : '';
    const size = sizeIcon ? 24 : 32;

    const whatsappLink = isMobile
      ? `whatsapp://send?text=${shareText}`
      : `https://api.whatsapp.com/send?text=${shareText}`;
    return (
      <div
        className={cx(styles.shareWrapper, className)}
      >
        {!this.props.isCloseЕitle &&
          <div className={styles.shareTitle}>
            <span className={`icon icon-contacts-share${iconShouldFill}`} />
            <span>{translate('propertyDetails', 'shareTitle')}:</span>
          </div>
        }
        <div>
          <div className={cx(styles.row, {
            [styles.column]: inColumn
          })}
          >
            <div className={styles.shareRow}>
              <FacebookShareButton
                url={protocol + sharingUrl}
                beforeOnClick={this.trackShareClick}
              >
                <div className={styles.iconWrapper}>
                  {this.renderFacebookIcon()}
                  {withSocialName && <span className={styles.name}>Facebook</span>}
                </div>
              </FacebookShareButton>
            </div>
            <a
              className={styles.shareRow}
              href={whatsappLink}
              target="_blank"
              data-action="share/whatsapp/share"
            >
              <div className={styles.iconWrapper}>
                {this.renderWhatsAppIcon()}
                {withSocialName && <span className={styles.name}>Whatsapp</span>}
              </div>
            </a>

            <CopyToClipboard
              text={sharingUrl && (protocol + sharingUrl).replace(/www./g, '')}
              onCopy={this.handleCopyLink}
            >
              <div
                className={cx(styles.shareRow, {
                  [styles.copyWrapper]: inColumn
                })}
              >
                {this.state.linkCopied ? this.renderCopiedButton() : this.renderShouldCopyButton()}
                {withSocialName && (
                  <span className={styles.name}>{translate(this.state.linkCopied ? 'copiedLink' : 'copyLink')}</span>
                )}
              </div>
            </CopyToClipboard>
            {this.renderShareEmail(protocol + sharingUrl)}
          </div>
        </div>
      </div>
    );
  }
}

ShareBlock.propTypes = {
  locale: PropTypes.string,
  emailTitle: PropTypes.string,
  className: PropTypes.string,
  copyLinkTitle: PropTypes.string,
  sharingData: PropTypes.object,
  hideTooltip: PropTypes.func,
  translate: PropTypes.func,
  sizeIcon: PropTypes.number,
  iconFill: PropTypes.bool,
  isMobile: PropTypes.bool,
  isCloseЕitle: PropTypes.bool,
  inColumn: PropTypes.bool,
  withSocialName: PropTypes.bool
};
